import { Component, OnInit } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { AuthService } from "app/core/services/auth.service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {


  email: string;

  callback: string = environment.APP_ROOT + "/auth/password/reset"; //environment
  requestInProgress: boolean = false;
  resetRequestSent: boolean = false;

  error: string = null;

  submitted = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.requestInProgress = false;
    this.resetRequestSent = false;
  }

  async resetPassword() {

    this.submitted = true;


    if (this.email) {

      this.requestInProgress = true;


      try {
        await this.authService.requestPasswordReset(this.email, this.callback);

        this.requestInProgress = false;
        this.resetRequestSent = true;

      }
      catch (error) {

        //show request received message regardless of the result, so users can't tell which email address 


        this.requestInProgress = false;

        if (error.status == 404) {
          //no such email address
          this.error = "Account with the email address was not found.";
        } else {
          //general error
          this.error = "There was an error while processing your request.";
        }
      }





      // this.authService.requestPasswordReset(this.email, this.callback).then(
      //   result => {
      //     console.log(result);

      //     this.requestInProgress = false;
      //     this.resetRequestSent = true;
      //   },
      //   error => {
      //     console.log(error);

      //     this.requestInProgress = false;

      //     if (error.status == 404) {
      //       //no such email address
      //       this.error = "Email address not found.";
      //     } else {
      //       //general error
      //     }
      //   }
      // );
    }



  }

}
